import React from 'react';

interface Props {
  value: number; // 0..100
  height?: 'sm' | 'md';
  tone?: 'violet' | 'emerald';
}

/**
 * Barre de progression déterminée. Utilisée dans les cards projet,
 * dans le stepper, etc. Fond neutre + remplissage violet (DS Sillant).
 */
const ProgressBar: React.FC<Props> = ({ value, height = 'sm', tone = 'violet' }) => {
  const h = height === 'sm' ? 'h-1.5' : 'h-2';
  const fill = tone === 'emerald' ? 'bg-emerald-500' : 'bg-violet-500';
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className={`w-full ${h} bg-gray-100 rounded-full overflow-hidden`}>
      <div
        className={`${h} ${fill} rounded-full transition-all duration-300`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default ProgressBar;
